import { mapGetters } from 'vuex';
import ImageUrlFallback from '../../mixins/imageUrlFallback'
import Accounting from '../../mixins/accounting'
import Tooltip from '../shared/Tooltip'
import Button from '../shared/Button'
import branding from '../../mixins/branding';
require('./scss/vehicle-visual-summary.scss');
import ProductDetails from '../../lang/ProductDetails';
import ProductDetailsComponent from './ProductDetails';

export default {
    name:'VehicleVisualSummary',
    mixins: [Accounting, ImageUrlFallback, branding],
    i18n: ProductDetails,
    props: {
        vehicle: Object,
        currentVehicle: Object,
        currencyIsChanging: Boolean,
        activeProduct: Object,
        labels: Object,
        titlePosition: {
            type: String,
            default: 'top'
        },
        cardType: {
            type: String,
            default: 'other-card'
        },
        toggleExpanded: {
            type: Function,
            default: () => {}
        },
    },
    components: {
        'gm-tooltip': Tooltip,
        'product-details': ProductDetailsComponent,
    },
    computed:
        {

            fuelType() {
                let label = this.vehicle.fuel || '';

                if (this.vehicle.fuel === 'Petrol/Diesel') {
                    label = this.labels.fuel;
                }

                label = label.toLowerCase();

                let translationFuel = this.$t('ProductDetails.spec_fuel_petrol');

                if (label === 'petrol' && translationFuel !== 'ProductDetails.spec_fuel_petrol') {
                    label = this.$t('ProductDetails.spec_fuel_petrol');
                } else if (label === 'petrol/diesel' || label === 'diesel/petrol') {
                    translationFuel = this.$t('ProductDetails.spec_fuel_petrol_diesel');
                    if (translationFuel !== 'ProductDetails.spec_fuel_petrol_diesel') {
                        label = this.$t('ProductDetails.spec_fuel_petrol_diesel');
                    }
                }

                let icon = 'fuel-type-icon.svg';

                if (['Hybrid', 'Electric'].indexOf(this.vehicle.fuel) > -1) {
                    icon = 'battery-icon.svg';
                }

                  if (['Hydrogen'].indexOf(this.vehicle.fuel) > -1) {
                    icon = 'hydrogen-icon.svg';
                }

                return label ? {
                    label: label,
                    icon,
                } : null;
            },
            loyaltyDiscountApplied() {
                return this.vehicle.loyalty_discount_applied && this.userLoyalty;
            },
            luggageLabel() {
                let luggageTypes = {
                    short: [],
                    long: [],
                };

                if (this.vehicle.luggage_large) {
                    luggageTypes.short.push(
                        this.vehicle.luggage_large + this.labels.luggage.large.short
                    );
                    luggageTypes.long.push(
                        `${this.vehicle.luggage_large} ${this.labels.luggage.large.long}`
                    );
                }

                if (this.vehicle.luggage_medium) {
                    luggageTypes.short.push(
                        this.vehicle.luggage_medium + this.labels.luggage.medium.short
                    );
                    luggageTypes.long.push(
                        `${this.vehicle.luggage_medium} ${this.labels.luggage.medium.long}`
                    );
                }

                if (this.vehicle.luggage_small) {
                    luggageTypes.short.push(
                        this.vehicle.luggage_small + this.labels.luggage.small.short
                    );
                    luggageTypes.long.push(
                        `${this.vehicle.luggage_small} ${this.labels.luggage.small.long}`
                    );
                }

                return {
                    short: luggageTypes.short.join(', '),
                    long: luggageTypes.long.join(', '),
                };
            },

            transmission() {
                let label = this.vehicle.transmission || '';
                let icon = 'transmission-manual-icon.svg';
                if(label.length === 0){
                    //no-op
                } else if (label.toLowerCase().indexOf('manual') > -1) {
                    label = this.labels.transmission.manual;
                } else {
                    label = this.labels.transmission.automatic;
                    icon = 'transmission-auto-icon.svg';
                }

                return {
                    label: label.toLowerCase(),
                    icon,
                };
            },
            totals() {
                return this.$store.getters.getTotals;
            },
            quotePaymentType() {
                return this.$store.getters.quotePaymentType;
            },
            ...mapGetters({
                selectedCurrency: 'selectedCurrency',
                user: 'getQuoteUser',
            })
        },
    methods: {
        toggleDetails() {
            this.shouldShowDetails = !this.shouldShowDetails;
            this.toggleExpanded(this.shouldShowDetails);
        },
    },
    data() {
        return {
            imageErrorUrls: [],
            shouldShowDetails: false,
            url: null,
        }
    },

    template: `
    <div class="vehicle-block" :class="{'expanded': shouldShowDetails}">
        <div class="vehicle-header" v-if="titlePosition === 'top'">
            <h5 :class="{'with-drivego-icon':currentVehicle.is_drive_and_go}" class="w-75">
                <img :src="brandingImagesPath('/images/svgs/dg-icon.svg')" class="drivego-icon" v-if="currentVehicle.is_drive_and_go">{{ currentVehicle.name }}
            </h5>
            <strong class="amount" v-if="currencyIsChanging">&hellip;</strong>
            <strong class="amount ml-4" v-else-if="activeProduct && activeProduct.total_price > 0">
                <div class="text-uppercase p-0">
                    <button
                        v-if="!currentVehicle.is_drive_and_go"
                        class="btn btn-secondary d-flex align-items-center justify-content-center dropdown-toggle details-btn mobile-details-btn rounded-pill text-capitalize mt-4 mr-3 ml-2 px-2 collapsed float-right h3"
                        @click="toggleDetails"
                    >

                        <span class="details-button-vehicles">{{ labels.details }}</span>
                        <i class="fa fa-fw fa-chevron-up ml-2" v-if="shouldShowDetails"></i>
                        <i class="fa fa-fw fa-chevron-down ml-2" v-else></i>
                    </button>
                </div>
            </strong>
        </div>
        <div :class="['vehicle-img', {'row m-0': cardType === 'us-source-booking'}, {'expanded': shouldShowDetails}]">
            <p class="group-code text-muted">{{ vehicle.group }}</p>

            <div :class="['vehicle-img-wrapper', {'col-4 p-1': cardType === 'us-source-booking'}, {'expanded': shouldShowDetails}]" :style="cardType === 'us-source-booking' ? 'background-image:url('+ imageUrl(currentVehicle.image) +')':''" v-if="currentVehicle.image">
                <div class="vehicle-image-overlay d-block d-lg-none" :class="{'expanded': shouldShowDetails}"></div>
                <img class="vehicle-image vehicle-fixed-height" :class="{'expanded': shouldShowDetails}" :src="imageUrl(currentVehicle.image)" alt="" @error="imageLoadFailed(currentVehicle.image)"/>
                <img
                        class="loyalty-medal"
                        :src="userLoyalty.image"
                        :alt="userLoyalty.name"
                        v-if="loyaltyDiscountApplied"
                />
            </div>
            <div :class="['vehicle-header', {'col-8 p-1': cardType === 'us-source-booking'}]" v-if="titlePosition !== 'top'">
                <h5 :class="{'with-drivego-icon':currentVehicle.is_drive_and_go}">
                <img :src="brandingImagesPath('/images/svgs/dg-icon.svg')" class="drivego-icon" v-if="currentVehicle.is_drive_and_go">{{ currentVehicle.name }}
                </h5>
                <strong class="amount" v-if="currencyIsChanging">&hellip;</strong>
                <strong class="amount" v-else-if="activeProduct && activeProduct.total_price > 0">{{ priceWithPaymentType(totals, quotePaymentType) }}</strong>
            </div>
            <div :class="['vehicle-specs-icons', {'col-12 p-3 pb-3': cardType === 'us-source-booking'}, {'expanded': shouldShowDetails}]">
                <div class="icon-spec" v-if="currentVehicle.refrigerated">
                    <div class="vehicle-spec-item-icon">
                        <img :src="brandingImagesPath('/images/specs-icons/refrigerated-icon.svg')" alt="Refrigerated"/>
                    </div>
                    <div class="vehicle-spec-item-description">
                        {{ labels.refrigerated }}
                    </div>
                </div>
                <div class="icon-spec" v-if="currentVehicle.adults">
                    <div class="vehicle-spec-item-icon">
                        <img :src="brandingImagesPath('/images/specs-icons/number-of-passengers-icon.svg')"/>
                    </div>
                    <div class="vehicle-spec-item-description">{{ currentVehicle.adults }}</div>
                </div>
                <div class="icon-spec" v-if="luggageLabel.short">
                    <gm-tooltip :text="luggageLabel.long" click="enabled">
                        <div class="vehicle-spec-item-icon">
                            <img :src="brandingImagesPath('/images/specs-icons/number-of-bags-icon.svg')" alt="Number of bags"/>
                        </div>
                    </gm-tooltip>
                    <div class="vehicle-spec-item-description">{{ luggageLabel.short }}</div>
                </div>
                <div class="icon-spec" v-if="currentVehicle.fuel">
                    <div class="vehicle-spec-item-icon">
                        <img :src="brandingImagesPath('/images/specs-icons/' + fuelType.icon)" alt="Fuel type"/>
                    </div>
                    <div class="vehicle-spec-item-description">{{ fuelType.label }}</div>
                </div>
                <div class="icon-spec" v-if="vehicle.co2 > 0">
                    <div class="vehicle-spec-item-icon">
                        <img :src="brandingImagesPath('/images/specs-icons/co2-icon.svg')" alt="CO2"/>
                    </div>
                    <div class="vehicle-spec-item-description">{{ currentVehicle.co2 }}<sub>2</sub></div>
                </div>
                <div class="icon-spec" v-if="currentVehicle.air_conditioning">
                    <div class="vehicle-spec-item-icon">
                        <img :src="brandingImagesPath('/images/specs-icons/aircon-icon.svg')" alt="Air con"/>
                    </div>
                    <div class="vehicle-spec-item-description">
                        {{ labels.airCon }}
                    </div>
                </div>
                <div class="icon-spec" v-if="currentVehicle.transmission">
                    <div class="vehicle-spec-item-icon">
                        <img :src="brandingImagesPath('/images/specs-icons/' + transmission.icon)" alt="Transmission"/>
                    </div>
                    <div class="vehicle-spec-item-description">{{ transmission.label }}</div>
                </div>
            </div>

            <transition v-if="shouldShowDetails" name="fade">
                <div class="details-section collapse row w-100" :class="{'expanded show': shouldShowDetails}">
                    <product-details
                        :product="activeProduct"
                        :vehicle="vehicle"
                        :currency-is-changing="currencyIsChanging"
                        upsell-card-type="mobile-us-product-upsell"
                    ></product-details>
                </div>
            </transition>
        </div>
    </div>
    `,
}
